import { withPrefix } from "gatsby";
import { Link } from "gatsby";
import * as React from 'react';
export default {
  withPrefix,
  Link,
  React
};